import * as React from 'react'

import { cn } from '@/lib/utils'

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-xl border border-input bg-background px-3 py-2 text-sm leading-5 shadow-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[#2f2a9c] placeholder:text-sm placeholder:font-normal placeholder:text-[#7C8D9F] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#5e619d] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:bg-[#f3f3ff] disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
